// This file is generated by a script. Do not edit this file directly.
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "react"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("react"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.react);
    global.Attachment = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports, _react) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.Attachment = void 0;
  _react = _interopRequireWildcard(_react);
  var React = _react;
  function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
  function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
  function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
  var Attachment = _exports.Attachment = function Attachment(props) {
    return /*#__PURE__*/React.createElement("svg", _extends({
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 20 20"
    }, props), /*#__PURE__*/React.createElement("path", {
      fill: "currentColor",
      d: "M8.588 18.125c-1.591 0-3.074-.607-4.175-1.71-2.321-2.329-2.285-6.153.08-8.525l4.774-4.787a4.15 4.15 0 0 1 2.956-1.227c1.117 0 2.168.436 2.957 1.227a4.203 4.203 0 0 1 0 5.925l-4.797 4.809c-.906.91-2.489.91-3.399 0a2.414 2.414 0 0 1 0-3.403l4.214-4.226a.625.625 0 0 1 .885.884L7.87 11.317a1.16 1.16 0 0 0 0 1.638c.434.437 1.194.436 1.628 0l4.797-4.809a2.95 2.95 0 0 0 0-4.16c-1.107-1.11-3.036-1.11-4.142 0L5.379 8.774c-1.849 1.854-1.885 4.95-.08 6.76.864.866 2.032 1.343 3.29 1.343 1.288 0 2.544-.518 3.446-1.423l4.19-4.201a.625.625 0 0 1 .885.883l-4.19 4.202a6.16 6.16 0 0 1-4.332 1.788"
    }));
  };
});
